// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasCategorias_CarregaCategoriaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/despesas_categorias/carrega_categoria/<id>
 *
 * Returns a single expense category row. The dados is the flat row itself
 * (object-shaped): the same five columns of `config_despesas_categorias`
 * emitted per-item by the sibling list endpoint
 * (/config/despesas_categorias/carrega_categorias).
 *
 * `despesa_categoria_status` and `despesa_categoria_investimento` are stored
 * as TINYINT (0/1). `despesa_categoria_percentual_padrao` is stored as INT
 * (whole percent). All four numeric fields are NOT NULL in the schema.
 *
 * @see Despesas_categorias_model::getById()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DespesasCategorias_CarregaCategoriaResponseDados {
despesa_categoria_id: number
despesa_categoria_titulo: string
despesa_categoria_status: number
despesa_categoria_investimento: number
despesa_categoria_percentual_padrao: number
despesa_categoria_exige_nf: number
despesa_categoria_grupo_dre?: string
despesa_categoria_descricao?: string
despesa_categoria_grupo_pex?: string
despesa_categoria_natureza?: string
despesa_categoria_subcategoria?: string
}

export type DespesasCategorias_CarregaCategoriaResponse = ApiResponse<DespesasCategorias_CarregaCategoriaResponseDados>;

registerResponseContract('DespesasCategorias_CarregaCategoriaResponse', {
  despesa_categoria_id:                { type: 'number',  required: true },
  despesa_categoria_titulo:            { type: 'string',  required: true },
  despesa_categoria_status:            { type: 'number',  required: true },
  despesa_categoria_investimento:      { type: 'number',  required: true },
  despesa_categoria_percentual_padrao: { type: 'number',  required: true },
  despesa_categoria_exige_nf:          { type: 'number',  required: true },
  despesa_categoria_grupo_dre:         { type: 'string',  required: false },
  despesa_categoria_descricao:         { type: 'string',  required: false },
  despesa_categoria_grupo_pex:         { type: 'string',  required: false },
  despesa_categoria_natureza:          { type: 'string',  required: false },
  despesa_categoria_subcategoria:      { type: 'string',  required: false },
})
